import React from "react";

// INPUT
// * key
// * onChange => (value)
// type = "button", "checkbox", "color", "date", "datetime-local", "email", "file", "number", "image", "month", "password", "radio", "range", "reset", "tel", "time", "url", "week"
// checked (bool)
// "formaction" (for image type)
// disabled
// accept (type = file) = corresponds to the Extension
// max
// min
// maxlength
// minlength
// pattern (regex)
// required
// placeholder
// src (type=image)
// value
// width (type = image)

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value === 0 || (this.props.value && this.props.value !== null) ? this.props.value : "",
    };
    this.onInputChange = this.onInputChange.bind(this);
  }

  onInputChange(event) {
    var value = event.target.value;
    this.props.onChange(value);
    this.setState({ value });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value || this.props.value !== this.state.value) {
      this.setState({ value: this.props.value });
    }
  }

  render() {
    var { onChange, className, type, error, value, ...newProps } = this.props;
    return (
      <input
        onChange={this.onInputChange}
        type={type ? type : "text"}
        value={
          value === 0 || (value && value !== null) ? this.state.value : ""
        }
        className={error ? "block w-full bg-white border border-red-400 rounded-[11px] h-[44px] px-3.5 text-sm focus:outline-none transition-colors" : "block w-full bg-white border rounded-[11px] h-[44px] px-3.5 text-sm focus:outline-none transition-colors"}
        style={!error ? { borderColor: '#e7eaef' } : {}}
        {...newProps}
      />
    );
  }
}

export default Input;
